export enum LanguageEnum {
    GERMAN = 'GERMAN',
    ENGLISH_GB = 'ENGLISH_GB',
    ENGLISH_US = 'ENGLISH_US',
    SERBIAN = 'SERBIAN'
}

export function getLanguageCodeByLanguageEnum(language: LanguageEnum): string {
    switch (language) {
        case LanguageEnum.GERMAN:
            return 'de';
        case LanguageEnum.SERBIAN:
            return 'sr';
        case LanguageEnum.ENGLISH_GB:
        case LanguageEnum.ENGLISH_US:
            return 'en';
        default:
            return 'de';
    }
}

export function getLanguageEnumByLanguageCode(languageCode: string): LanguageEnum {
    switch (languageCode) {
        case 'en':
            return LanguageEnum.ENGLISH_GB;
        case 'de':
            return LanguageEnum.GERMAN;
        case 'sr':
            return LanguageEnum.SERBIAN;
        default:
            return LanguageEnum.GERMAN;
    }
}

export function getTextBasedOnLanguage(language: LanguageEnum, english: string, german: string, serbian: string): string {
    switch (language) {
        case LanguageEnum.GERMAN:
            return german ? german : '';
        case LanguageEnum.SERBIAN:
            return serbian ? serbian : '';
        default:
            return english ? english : '';
    }
}


